import type { FC } from 'react';

interface Props {
  className?: string;
}

const ParkingIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="3" y="5" width="18" height="14" rx="2" strokeWidth="2" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 8h4a3 3 0 010 6h-4V8z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 11h3" />
    </svg>
  );
};

export default ParkingIcon;
